if (!customElements.get('cro-mobile-product-features')) {
  const originalPositions = new Map();

  customElements.define(
    'cro-mobile-product-features',
    class extends HTMLElement {
      constructor() {
        super();
        this.mobileQuery = window.matchMedia('(max-width: 749.98px)');
        this.relocateFeatures = this.relocateFeatures.bind(this);
      }

      connectedCallback() {
        this.mobileQuery.addEventListener('change', this.relocateFeatures);
        window.addEventListener('resize', this.relocateFeatures);
        document.addEventListener('DOMContentLoaded', this.relocateFeatures, { once: true });
        document.addEventListener('shopify:section:load', this.relocateFeatures);
        this.relocateFeatures();
      }

      disconnectedCallback() {
        this.mobileQuery.removeEventListener('change', this.relocateFeatures);
        window.removeEventListener('resize', this.relocateFeatures);
        document.removeEventListener('DOMContentLoaded', this.relocateFeatures);
        document.removeEventListener('shopify:section:load', this.relocateFeatures);
        this.restoreFeatures();
      }

      relocateFeatures() {
        if (!this.isConnected || !this.closest('.cro-product-main')) return;

        const selector = `.shopify-section.feature-type1[id$="__${this.dataset.sectionKey}"]`;
        const featureSection = document.querySelector(selector);
        if (!featureSection) return;

        this.featureSection = featureSection;
        let originalPosition = originalPositions.get(featureSection.id);
        if (!originalPosition?.isConnected) {
          originalPosition = document.createComment('Original product feature section position');
          featureSection.before(originalPosition);
          originalPositions.set(featureSection.id, originalPosition);
        }

        if (this.mobileQuery.matches) {
          if (featureSection.parentElement !== this) this.append(featureSection);
        } else {
          this.restoreFeatures();
        }
      }

      restoreFeatures() {
        if (this.featureSection?.parentElement !== this) return;
        const originalPosition = originalPositions.get(this.featureSection.id);
        if (originalPosition?.isConnected) originalPosition.after(this.featureSection);
      }
    }
  );
}
